import React, {Component} from 'react';

class HomeIcon extends Component {
  render() {
    const {name} = this.props;
    const path = `/icons/${name}.svg`;

    return (
      <img className='home-icon' src={path} alt='Icon' />
    );
  }
}

export default HomeIcon;
